// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  fluxId: __t.u64().primaryKey().name("flux_id"),
  whKey: __t.string().name("wh_key"),
  massUsed: __t.u32().name("mass_used"),
  collapsed: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
});
